<div fxLayout="column" fxFlex fxLayoutGap="24px">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2>Create client</h2>
    <button mat-icon-button [routerLink]="['../']" matTooltip="Back to Client List">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>

  <form [formGroup]="clientForm" (ngSubmit)="onSubmit()">
    <mat-card>
      <mat-card-content fxLayout="column" fxLayoutGap="16px">
        <mat-form-field appearance="outline">
          <mat-label>Client ID</mat-label>
          <input
            matInput
            formControlName="clientId"
            placeholder="Enter unique client identifier"
            required
          />
          @if (clientForm.get('clientId')?.hasError('required')) {
            <mat-error> Client ID is required </mat-error>
          }
          @if (clientForm.get('clientId')?.hasError('minlength')) {
            <mat-error> Client ID must be at least 1 character long </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Description</mat-label>
          <input
            matInput
            formControlName="description"
            placeholder="Optional description for this client"
          />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Roles</mat-label>
          <mat-select formControlName="roles" multiple>
            @for (role of roles; track role) {
              <mat-option [value]="role">
                {{ role }}
              </mat-option>
            }
          </mat-select>
          <mat-hint>Select one or more roles for this client</mat-hint>
        </mat-form-field>
      </mat-card-content>

      <mat-card-actions fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <button mat-button type="button" (click)="onCancel()" [disabled]="isSubmitting">
          Cancel
        </button>
        <button
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="clientForm.invalid || isSubmitting"
        >
          @if (loaded) {
            {{ isSubmitting ? 'Updating...' : 'Update Client' }}
          } @else {
            {{ isSubmitting ? 'Creating...' : 'Create Client' }}
          }
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
